import type {
  AuthRepository,
  LoginCredentials,
  SessionClient,
} from "@phurshell/psiapp-frontend-core/domain";
import { LoginError, UserTypes } from "@phurshell/psiapp-frontend-core/domain";

/**
 * Monta o objeto de sessão do usuário logado.
 *
 * TRANSIÇÃO: hoje é o `UserService.prepareUserData` (formato legado, lido pelas
 * telas antigas: formatted_image, default_payment_method...). Quando as telas
 * lerem o `UserPatient` do core, trocar por `userRepo.getPatientById`, preservando o
 * default_payment_method da sessão e sem mexer no core (ver ENTREGAS F01).
 */
export type LoadSession = (userId: number) => Promise<any>;

export const NOT_A_PATIENT_MESSAGE = "Este email de acesso não pertence a um paciente";

export class Login {
  constructor(
    private readonly authRepo: AuthRepository,
    private readonly sessionClient: SessionClient,
    private readonly loadSession: LoadSession,
  ) {}

  async execute(credentials: LoginCredentials): Promise<any> {
    const { user, access_token } = await this.authRepo.login(credentials);

    if (user.type !== UserTypes.user) {
      throw new LoginError(NOT_A_PATIENT_MESSAGE);
    }

    this.sessionClient.saveAuthToken(access_token);

    const session = await this.loadSession(user.id);
    if (!session) {
      this.sessionClient.destroySession();
      throw new LoginError("Não foi possível carregar seus dados. Tente novamente.");
    }

    this.sessionClient.saveSession(session);
    return session;
  }
}
